"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TAG_COLORS", {
  enumerable: true,
  get: function () {
    return _Tag.TAG_COLORS;
  }
});
Object.defineProperty(exports, "TAG_SIZES", {
  enumerable: true,
  get: function () {
    return _Tag.TAG_SIZES;
  }
});
Object.defineProperty(exports, "TAG_SPACING", {
  enumerable: true,
  get: function () {
    return _Tag.TAG_SPACING;
  }
});
Object.defineProperty(exports, "TAG_TEXT", {
  enumerable: true,
  get: function () {
    return _Tag.TAG_TEXT;
  }
});
exports.Tag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tag = require("./styles/Tag");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Tag = exports.Tag = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    textId,
    textValues = {},
    color = _Tag.TAG_COLORS.PRIMARY,
    size = _Tag.TAG_SIZES.MEDIUM,
    spacing = _Tag.TAG_SPACING.DEFAULT,
    dataCy = 'tag',
    className = '',
    style,
    icon,
    classNameOverrides,
    outlineColor
  } = {
    ...(props || {})
  };
  return /*#__PURE__*/_react.default.createElement("span", {
    ref: ref,
    role: "heading",
    "aria-level": "3",
    "data-testid": dataCy,
    "data-cy": dataCy,
    style: {
      ...style,
      outline: outlineColor ? `solid 1px ${outlineColor}` : 'none'
    },
    className: (0, _classnames.default)('tag-base', 'ms-2', color, size, spacing, className, {
      'tag-with-icon': Boolean(icon),
      'd-inline-flex': Boolean(icon) && !classNameOverrides?.overrideDisplayInlineFlex,
      'align-items-center': Boolean(icon)
    })
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "tag-icon"
  }, icon), textId && /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: textId,
    values: textValues
  }));
});
Tag.propTypes = {
  textId: _propTypes.default.string.isRequired,
  textValues: _propTypes.default.object,
  color: _propTypes.default.oneOf(Object.values(_Tag.TAG_COLORS)),
  size: _propTypes.default.oneOf(Object.values(_Tag.TAG_SIZES)),
  spacing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['', ...Object.values(_Tag.TAG_SPACING)]), _propTypes.default.string]),
  dataCy: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  icon: _propTypes.default.node,
  classNameOverrides: _propTypes.default.shape({
    overrideDisplayInlineFlex: _propTypes.default.bool
  }),
  outlineColor: _propTypes.default.string
};